import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const StyledNavigationList = withViewportStyle("div")<{
  isCentered: boolean;
  isMenuOpen: boolean;
}>`
  display: grid;
  grid-auto-flow: column;
  gap: ${rem(36)};
  text-align: center;
  width: max-content;
  margin: ${({ isCentered }) => (isCentered ? "auto" : "unset")};
  padding: ${rem(12)} ${rem(8)};
  background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};

  > a,
  // legacy seldon structure
  > div div {
    &:not(:last-of-type) {
      position: relative;
  
      &::after {
        content: "·";
        position: absolute;
        top: 50%;
        right: ${rem(-18)};
        transform: translateY(-50%);
        color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
      }
    }
  }

  .button-primitive {
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
    font-weight: 600;
    font-size: ${rem(14)};
    line-height: ${rem(32)};
    display: block;
    padding: 0 ${rem(12)};
    background-color: transparent;
  }

  ${(props) => props.$viewport.mobile`
      position: absolute;
      z-index: var(--z-index-lowest);
      top: ${rem(56)};
      overflow: auto;
      width: 100%;
      max-width: 100%;
      height: calc(100vh - ${rem(56)});
      padding: ${rem(8)} ${rem(80)} ${rem(32)};
      display: ${props.isMenuOpen ? "flex" : "none"};
      flex-direction: column;
      row-gap: ${rem(48)};

      .button-primitive {
        font-size: ${rem(18)};
        line-height: ${rem(32)};
        padding: 0;
        word-break: break-word;
      }

      > a,
      // legacy seldon structure
      > div div {
        &:not(:last-of-type)::after {
          top: unset;
          right: 50%;
          bottom: ${rem(-24)};
          transform: translateY(50%);
        }
      }
    }
  `}
`;
